import React, { Component } from "react";
import { Table, Tag, Tooltip, Divider, Row } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Backup, FindInPage, Beenhere, Cancel } from "@material-ui/icons";
import Axios from "../../../config/axios";
import styles from "assets/jss/material-kit-react/views/profilePage.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import classNames from "classnames";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import withErrorHandler from "hoc/withErrorHandler";
import moment from "moment";
import "../../../style.css";
import UploadModal from "./UploadModal";
import openNotificationWithIcon from "helpers/notification";
import Loading from "components/Loading";

const BLANK_IMAGE =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAAtJREFUGFdjYAACAAAFAAGq1chRAAAAAElFTkSuQmCC";
class MyLetters extends Component {
  state = {
    letters: [],
    uploadModal: false,
    uploadedFile: null,
    loading: false,
    selectedLetter: {
      addressed: {},
      requested_file: "",
      response_file: "",
      signature: "",
      signature_date: "",
    },
    count: {
      submitted: 0,
      processed: 0,
      finished: 0,
      rejected: 0,
    },
    trimmedDataURL: null,
    screenWidth: 0,
  };

  componentDidMount() {
    if (this.props.location.state && this.props.location.state.message) {
      openNotificationWithIcon(
        "success",
        "Permohonan Surat",
        this.props.location.state.message,
        "bottomRight"
      );
      this.props.history.replace({
        ...this.props.location.pathname,
        state: null,
      });
    }

    this.fetchLetters();
    this.fetchCountData();

    this.setState({
      screenWidth: window.innerWidth,
    });
  }

  fetchLetters = () => {
    Axios.get("/requested-letters", {
      params: {
        requester: this.props.user.user_id,
        sort_field: "_id",
        sort_order: -1,
      },
    }).then((response) => {
      this.setState({ letters: response.data.payload });
    });
  };

  handleSelctedRow = (record) => {
    this.setState({ selectedLetter: record });
  };

  /* upload surat */

  toggleUploadModal = () => {
    this.setState({ uploadModal: !this.state.uploadModal, uploadedFile: null });
  };

  handlOpenUploadModal = async (record) => {
    this.handleSelctedRow(record);
    this.toggleUploadModal();
  };

  handleChangeFile = (e) => {
    this.setState({ uploadedFile: e.target.files[0] });
  };

  handleUploadFile = () => {
    if (!this.state.uploadedFile) {
      this.toggleUploadModal();
      openNotificationWithIcon(
        "error",
        "Upload Surat",
        "Berkas tidak boleh kosong.",
        "bottomRight"
      );
      return;
    }

    this.handleUploaLetter();
  };

  handleUploaLetter = () => {
    const record = this.state.selectedLetter;
    this.setState({ loading: true });
    var formData = new FormData();
    const id = record._id;
    delete record._id;
    Object.keys(record).forEach((key) => {
      if (key === "fields_value" || key === "response_fields_value") {
        record[key].forEach((value) => {
          formData.append("fields_value[]", JSON.stringify(value));
        });
      } else if (key === "addressed") {
        formData.append(key, JSON.stringify(record[key]));
      } else if (key === "requested_file") {
        formData.append(
          "requested_file",
          record.signature_type === "manual"
            ? this.state.uploadedFile
            : record.requested_file
        );
      } else if (
        (key === "thesis" ||
          key === "thesis_defence" ||
          key === "thesis_submission") &&
        record[key]
      ) {
        record.doping_doji.forEach((value) => {
          formData.append("doping_doji[]", JSON.stringify(value));
        });
      } else if (key === "internship_member") {
        record.internship_member.forEach((value) => {
          formData.append("internship_member[]", JSON.stringify(value));
        });
      } else if (key === "thesis_detail") {
        formData.append(key, JSON.stringify(record[key]));
      } else {
        if (!["doping_doji", "internship_member"].includes(key)) {
          formData.append(key, record[key] !== null ? record[key] : "");
        }
      }
    });

    this.toggleUploadModal();
    Axios.put("/requested-letters/save/" + id, formData)
      .then(() => {
        this.setState({ loading: false });
        this.fetchLetters();
        openNotificationWithIcon(
          "success",
          "Upload Surat",
          "Surat Berhasil Diupdate",
          "bottomRight"
        );
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  /* ------------------------------------------------------ */

  /* online signature */

  onSaveSignature = (signature) => {
    if (signature === BLANK_IMAGE) {
      this.toggleUploadModal();
      openNotificationWithIcon(
        "error",
        "Upload Surat",
        "Tanda tangan tidak boleh kosong.",
        "bottomRight"
      );
      return;
    }

    let { selectedLetter } = this.state;
    selectedLetter.signature = signature;
    selectedLetter.signature_date = new Date();
    this.setState({ selectedLetter }, () => this.handleUploaLetter());
  };

  /* -------------------------------------------------------------- */

  fetchCountData = () => {
    Axios.get("/report/count-data?requester=" + this.props.user.identity).then(
      (response) => {
        this.setState({ count: response.data });
      }
    );
  };

  handleFillSurvey = () => {
    const record = this.state.selectedLetter;
    this.setState({ loading: true });
    const id = record._id;

    Axios.post(`/requested-letters/fill-out-survey/${id}`).then(() => {
      window.open("https://survei.usu.ac.id", "_blank");
      window.location.reload();
    });
  };

  render() {
    const { classes } = this.props;
    const imageClasses = classNames(
      classes.imgRaised,
      classes.imgRoundedCircle,
      classes.imgFluid
    );

    const columns = [
      {
        title: "Tanggal Pengajuan",
        dataIndex: "submitted_date",
        width: 120,
        render: (data) => moment(data).format("lll"),
      },
      {
        title: "Surat",
        width: 200,
        render: (record) => (
          <div
            style={{ cursor: "pointer", color: "#55acee" }}
            onClick={() => this.handlOpenUploadModal(record)}
          >
            {record.letters_name}
          </div>
        ),
      },
      {
        title: "Status",
        key: "name",
        width: 180,
        render: ({ step, signature, requested_file, addressed }) => {
          const colors = {
            submitted: "orange",
            processed: "yellow",
            finished: "green",
            rejected: "red",
          };

          const text = {
            submitted: "Diajukan",
            processed:
              step === "processed" && !addressed.identity
                ? "Permohonan Diterima"
                : step === "processed" && (requested_file || signature)
                ? "Menunggu Surat Balasan"
                : "Menunggu Ttd Mahasiswa",
            finished: "Selesai",
            rejected: "Ditolak",
          };
          return (
            <Tag color={colors[step] || "blue"}>{text[step].toUpperCase()}</Tag>
          );
        },
      },
      {
        title: "Tahap",
        key: "name",
        width: 100,
        fixed: "right",
        render: (row) => (
          <>
            <Tooltip title="Permohonan Diterima">
              {row.step === "processed" ? (
                <CheckCircleOutlined style={{ color: "green" }} />
              ) : (
                <CloseCircleOutlined style={{ color: "red" }} />
              )}
            </Tooltip>
            <Divider type="vertical" />
            <Tooltip title="Upload/Tanda Tangani Surat Permohonan">
              {row.requested_file || row.signature ? (
                <CheckCircleOutlined style={{ color: "green" }} />
              ) : (
                <CloseCircleOutlined style={{ color: "red" }} />
              )}
            </Tooltip>
            <Divider type="vertical" />
            <Tooltip title="Surat Balasan">
              {row.step === "finished" ? (
                <CheckCircleOutlined style={{ color: "green" }} />
              ) : (
                <CloseCircleOutlined style={{ color: "red" }} />
              )}
            </Tooltip>
          </>
        ),
      },
    ];

    return (
      <div>
        <Parallax
          style={{ height: 300 }}
          filter
          image={require("assets/img/background.jpeg")}
        />
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div>
            <div className={classes.container}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={6}>
                  <div className={classes.profile}>
                    <div>
                      <img
                        src={this.props.user.info.foto}
                        alt="Foto Profil"
                        className={imageClasses}
                      />
                    </div>
                    <div className={classes.name}>
                      <h3 className={classes.title}>
                        {this.props.user.name || "Tidak ada nama"}
                      </h3>
                      <h6>
                        {this.props.user.info.program_studi ||
                          "Tidak ada program studi"}
                      </h6>
                    </div>
                  </div>
                </GridItem>
              </GridContainer>
              <GridContainer justify="center" style={{ marginTop: 50 }}>
                <GridItem xs={12} sm={12} md={8}>
                  <Card>
                    <CardHeader color="warning">Surat Saya</CardHeader>
                    {this.state.screenWidth <= 768 &&
                    this.state.screenWidth > 0 ? (
                      <GridContainer
                        justify="center"
                        style={{ marginTop: 10, marginBottom: 5 }}
                      >
                        <span>{`<< Geser Tabel Secara Horizontal >>`}</span>
                      </GridContainer>
                    ) : null}

                    <CardBody>
                      <Table
                        rowKey="_id"
                        columns={columns}
                        dataSource={this.state.letters}
                        pagination={{
                          pageSize: 10,
                        }}
                        scroll={{ x: 500 }}
                        loading={this.props.loading}
                      />
                    </CardBody>
                  </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <Card>
                    <CardHeader color="warning">Statistik</CardHeader>
                    <CardBody>
                      <ul style={{ listStyle: "none" }}>
                        <li style={{ padding: 5 }}>
                          <Row>
                            <Backup />
                            <span style={{ marginLeft: 7 }}>
                              {this.state.count.submitted} Sedang Diajukan
                            </span>
                          </Row>
                        </li>
                        <li style={{ padding: 5 }}>
                          <Row>
                            <FindInPage />
                            <span style={{ marginLeft: 7 }}>
                              {this.state.count.processed} Diproses
                            </span>
                          </Row>
                        </li>
                        <li style={{ padding: 5 }}>
                          <Row>
                            <Beenhere />
                            <span style={{ marginLeft: 7 }}>
                              {this.state.count.finished} Selesai
                            </span>
                          </Row>
                        </li>
                        <li style={{ padding: 5 }}>
                          <Row>
                            <Cancel />
                            <span style={{ marginLeft: 7 }}>
                              {this.state.count.rejected} Ditolak
                            </span>
                          </Row>
                        </li>
                      </ul>
                    </CardBody>
                  </Card>
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem>
                  <img src={this.state.trimmedDataURL} alt="" />
                </GridItem>
              </GridContainer>
            </div>
          </div>
        </div>

        <UploadModal
          toggle={this.toggleUploadModal}
          open={this.state.uploadModal}
          upload={this.handleUploadFile}
          onChangeFile={this.handleChangeFile}
          data={this.state.selectedLetter}
          onSave={this.onSaveSignature}
          onFillSurvey={this.handleFillSurvey}
        />

        <Loading loading={this.state.loading} />
      </div>
    );
  }
}

MyLetters.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withErrorHandler(withStyles(styles)(MyLetters), Axios);
